export const APP_BASE_URL = "https://app.nicolethemathlady.com";
export const MARKETING_BASE_URL = "https://nicolethemathlady.com";
